<div class="flex justify-between items-center mb-4">
  <h2 class="text-2xl font-semibold">Tipo de cargo</h2>
  <button
    (click)="openModal('add')"
    class="bg-primary text-white px-4 py-2 rounded transform transition-transform duration-200 cursor-pointer hover:scale-105"
    [disabled]="loadingJobTypes"
  >
    Crear nuevo tipo de cargo
  </button>
</div>
<app-loading
  *ngIf="loadingJobTypes"
  text="Cargando tipos de cargo"
></app-loading>
<div class="bg-white rounded border border-gray-200" *ngIf="!loadingJobTypes">
  <app-table-generic
    [columns]="columns"
    [data]="jobTypes"
    [actions]="actions"
    [showPagination]="false"
    (edit)="openModal('edit', $event)"
  >
  </app-table-generic>
</div>
<app-modal-form
  *ngIf="mostrarModalAgregar"
  [title]="'Crear tipo de cargo'"
  [form]="formAgregar"
  [fields]="fieldsAgregar"
  [loading]="loadingAgregar"
  (formSubmit)="crearJobType()"
  (cancel)="mostrarModalAgregar = false"
  submitText="Crear"
>
</app-modal-form>
<app-modal-form
  *ngIf="mostrarModalEditar"
  [title]="'Editar tipo de cargo'"
  [form]="formEditar"
  [fields]="fieldsEditar"
  [loading]="loadingEditar"
  submitText="Actualizar"
  (formSubmit)="actualizarJobType()"
  (cancel)="mostrarModalEditar = false"
>
</app-modal-form>
